/*
 * @Author: zhangwenbangde@163.com
 * @Date: 2019-04-18 16:45:53
 * */
import Vue from 'vue'
import VueRouter from 'vue-router'
import {routerMode} from '@/env'

import LocalStorage from "@/services/storage";

Vue.use(VueRouter);
console.log("process.env.BASE_URL")
console.log(process.env.BASE_URL)
console.log(process.env.NODE_ENV)
const routes = new VueRouter({
  mode: routerMode,
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/index/index.vue")
    },
    {
      path: "/index",
      name: "index",
      component: () => import("@/views/index/index.vue")
    },
    {
      path: "/article",
      name: "article",
      component: () => import("@/views/article/index.vue")
    },
    {
      path: "/articleList",
      name: "articleList",
      component: () => import("@/views/articleList/index.vue")
    },
    {
      path: "/tpic",
      name: "tpic",
      component: () => import("@/views/tpic.vue")
    },
    {
      path: "/ygic",
      name: "ygic",
      component: () => import("@/views/ygic.vue")
    },
    {
      path: "/gric",
      name: "gric",
      component: () => import("@/views/gric.vue")
    }
  ]
});

routes.beforeEach((to, from, next) => {
  // let loginStatus = LocalStorage.getLocalStorage('loginStatus');
  // console.log(to.meta.requireAuth)
  // if (to.meta.requireAuth) {
  //   if(!loginStatus) return next({path: "/index"});
  // }
  next();
});
// routes.beforeEach((to, from, next) => {

//   if(to.matched.some((item) => item.meta.login)){
//     // 如果是需要登录的，执行....
//     let info = JSON.parse(localStorage.getItem('userWhether'));
//     if(info === 200){  // 已经登录
//         next()
//     }else{
//       routes.push({
//         path: '/noPermission',
//         query: {
//           redirect: to.path.slice(1)
//         }
//       })
//     }

//     let loginStatus = LocalStorage.getLocalStorage('loginStatus');
//     if(loginStatus){
//       Resource.removeLogin
//         .post({}, { matrixContent: loginStatus})
//         .then(res => {
//           if (res.head.resultCode == 'SUCCESS') { // 已发送
//             let token = res.head.token;
//             LocalStorage.setLocalStorage('token', token, 90 * 24 * 60 * 60 * 1000);
//           }
//         })
//         .catch(err => {
//           console.log(err);
//         });
//     }
//   }else{
//     next()
//   }
// });


export default routes

